


import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'

import App from './App'
import router from'./router/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import axios from 'axios'
import clipboard from 'clipboard';
import dataV from '@jiaminghi/data-view'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



Vue.use(ElementUI);













import VueAMap from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css'

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
key: '135a80ff9deaf86a9ca021217fc4879e',
securityJsCode: '245304fd2aae393e05450c1b53c8f6fb'
});




import VueAmapThree from '@vuemap/vue-amap/dist/three.js'
Vue.use(VueAmapThree);

Vue.use(dataV)

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)

import '../src/assets/rem.js'

Vue.prototype.clipboard = clipboard

Vue.prototype.$http = axios;



FastClick.attach(document.body)

Vue.config.productionTip = false

Vue.use(VueRouter)

new Vue({
router,            //-----router文件
el: '#app-box',
template: '<App/>',
components: { App }
})










// WEBPACK FOOTER //
// ./src/main.js